import React, { useState, useEffect } from "react";
import throttle from "lodash/throttle";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { toggleBookingForm } from "../../actions/bookingActions";

const idLinks = [
  'how-it-works',
  'catalogue',
  'benefits'
]
const getPosition = (elements) => {
  const idPosition = elements.map((id) => {
   const element = document.getElementById(id)
   const start = element?.offsetTop
   const end = start + element?.clientHeight
   return { id, start, end };
  });
  return idPosition
}

const GenericNavComponent = ({ className, dispatch, member, brandConstants, lang, closeNavMenu }, context) => {
  const [activeMenu, setActiveMenu] = useState(null);
  useEffect(() => {
    const throttledCount = throttle(() => SectionOnView(getPosition(idLinks)), 500);
    window.addEventListener('scroll', throttledCount);
    return () => window.removeEventListener('scroll', throttledCount);
  }, []);

  const SectionOnView = (itemsList) => {
    const viewPort = window.innerHeight;
    // currentScroll line 1/2 of the current viewport
    const currentScrollY = window.scrollY + 1/2 * viewPort;
    const activeItem = itemsList.find((el) => {
      return el.start < currentScrollY  && currentScrollY < el.end
    })
    setActiveMenu(activeItem?.id || null)
  }
  // TODO: transform NavLink with "to" to a hash in to a function
  const isActive = (menu) => () => activeMenu === menu;
  const resortLinks = [
  { name: "SANDOS CARACOL ECO RESORT AND WATER PARK", url: "https://www.sandos.com/sandos-caracol/eco-all-inclusive-resort"  },
  { name: "SANDOS CANCUN", url: "https://www.sandos.com/sandos-cancun/cancun-mexico-resort-all-inclusive" },
  { name: "SANDOS PLAYACAR", url: "https://www.sandos.com/sandos-playacar/all-inclusive-resort-playa-del-carmen" },
  { name: "SANDOS FINISTERRA", url: "https://www.sandos.com/sandos-finisterra/los-cabos-all-inclusive-resort" },
  { name: "SANDOS MONACO", url: "https://www.sandos.com/sandos-monaco/beach-hotel-spa-all-inclusive" },
  { name: "SANDOS BENIDORM SUITES", url: "https://www.sandos.com/sandos-benidorm-suites/all-inclusive-hotel" },
  { name: "SANDOS EL GRECO", url: "https://www.sandos.com/sandos-el-greco/beach-hotel-all-inclusive" },
  { name: "SANDOS PAPAGAYO", url: "https://www.sandos.com/sandos-papagayo/beach-resort-all-inclusive" },
  { name: "SANDOS ATLANTIC GARDENS", url: "https://www.sandos.com/sandos-atlantic-gardens/lanzarote-all-inclusive" },
  { name: "SANDOS GRIEGO", url: "https://www.sandos.com/sandos-griego/all-inclusive-torremolinos-hotel" }
];

const reservationLinks = [
  { name: context.t("MEXICO AND OTHERS"), url: "tel:+525585266116" },
  { name: context.t("SPAIN AND EUROPE"), url: "tel:+34960479446" },
  { name: context.t("UNITED STATES OF AMERICA"), url: "tel:+18632234530" },
  { name: context.t("CANADA"), url: "tel:+16476916811" },
  { name: context.t("ARGENTINA"), url: "tel: 0 8008001464" },
  { name: context.t("BRAZIL"), url: "tel: 1132302292" },
  { name: context.t("UNITED KINGDOM"), url: "tel:+442038074491" },
];

  return (
    <>
    {!member && (
      <>
        <p>&nbsp;</p>
      </>
    )}
    {member && (
    <div
    style={{
      padding: "0px"
    }} 
    className={`flex items-center main-nav ${className || ""}`}>
      <div>
      <div className="dropdown">
        <label className="navbar-labels">
          {context.t("RESORTS")}
        </label>
        <div className="dropdown-content">
          {resortLinks.map(({ name, url }) => (
            <a key={name.toUpperCase()} href={url} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          ))}
        </div>
      </div>
      <a
        className="navbar-labels"
        href="https://www.sandos.com/special-offers"
        target="_blank"
        rel="noopener noreferrer"
      >
        {context.t("DEALS")}
      </a>
      <a
        className="navbar-labels"
        href="https://www.sandos.com/sandos4u"
        target="_blank"
        rel="noopener noreferrer"
      >
        {context.t("SANDOS4U")}
      </a>


      <a
        className="navbar-labels"
        href="https://bookingengine2.sandos.com/my-booking/en/?_ga=2.248081287.1825798511.1749073288-1642726940.1749073288"
        target="_blank"
        rel="noopener noreferrer"
      >
        {context.t("MY BOOKING")} 
      </a>

      <div className="dropdown">
        <label className="navbar-labels">{context.t("RESERVATIONS")}</label>
        <div className="dropdown-content">
          {reservationLinks.map(({ name, url }) => (
            <a key={name.toUpperCase()} href={url} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          ))}
        </div>
      </div>

      <label className="navbar-labels">
        {context.t("    ")} 
      </label>
      </div>
      <div style={{
          paddingLeft: "50px",
          paddingRight: "20px",
        }}>
      <button
        onClick={() => toggleBookingForm()(dispatch)}
        className="button-access-gradient hidden md:block"
      >
        {context.t("Book now")} 
      </button>
    </div>
    </div>
    
    )}
  </>
)};

GenericNavComponent.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  dispatch: PropTypes.func,
  member: PropTypes.object,
  brandConstants: PropTypes.object,
  lang: PropTypes.string,
};

GenericNavComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default GenericNavComponent;
